import { getAxiosClient } from "../../axios-client";
import { AddAvailabilityBody, AddAvailabilityResponse } from "./types";

const axiosClient = getAxiosClient();
export const addAvailability = async (body: AddAvailabilityBody) => {
  return await axiosClient.ax.post<AddAvailabilityResponse>(
    "/Availability/Add",
    body
  );
};
